import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import { getUrl } from '../utils/get-url.js';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../utils/http-client.js';

function useBloomreachRichText(html) {
    const page = useBrPageContext();
    if (html) {
        return html.replace(/<a href="([^"]*)"/g, (_, $1)=>{
            return `<a href="${getUrl($1, page)}"`;
        });
    }
    return '';
}

export { useBloomreachRichText };
//# sourceMappingURL=use-bloomreach-rich-text.js.map
